import React, { useEffect, useState } from "react";
import { isUiEvent } from "../logic/WidgetUtils";

// DevExtreme components
import { CheckBox } from 'devextreme-react/check-box';

// Component styles
import classes from "./CheckgroupWidget.module.scss";

const EMPTY = null;

export function CheckgroupWidget(props) {
  const { ui, data, config, writeBack } = props;
  const [localContent, setLocalContent] = useState(EMPTY);

  let widgetId = ui.id;
  let content = data && data.content ? JSON.parse(data.content) : null;
  let currentValues = localContent !== EMPTY ? localContent : content ? content.CurrentItemIds : [];
  let selectionCandidates = (content ? content.SelectionCandidates : null) || (config ? config.SelectionCandidates : null);
  let verticalLayout = config ? config.VerticalOrientation === true : false;
  let disabled = ui.readonly || (data && data.readonly);

  useEffect(() => {
    //console.log("CheckgroupWidget data of " + ui.id + ": ", data);
    setLocalContent(EMPTY);
  }, [data]);

  const rootStyle = {
    display: "flex",
    flexDirection: verticalLayout ? "column": "row",
    columnGap: "10px",
    rowGap: "5px"
  };

  const setContent = (args, itemId) => {
    if (!isUiEvent(args)) return;
    //console.log("CheckgroupWidget Checkbox click", itemId, args.value);
    let newContent = args.value ? [...currentValues, itemId] : currentValues.filter(id => id !== itemId);
    let value = JSON.stringify({ SelectedItemIds: newContent });
    setLocalContent(newContent);
    writeBack(value, true);
  };

  const renderCheckbox = (label, itemId) => {
    if (itemId === "null") return;
    let isSelected = currentValues.includes(itemId);
    return (
      <CheckBox
        className={classes.checkBox}
        key={itemId}
        id={itemId}
        value={isSelected}
        text={label}
        onValueChanged={e => setContent(e, itemId)}
        disabled={disabled}
      />
    );
  };

  return (
    <div id={widgetId} style={rootStyle} >
      {(selectionCandidates || []).map((candidate, index) => (
        renderCheckbox(candidate.DisplayData, candidate.ItemId, index)
      ))}
    </div>
  );
}